"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    stepTitle: {
        id: 'registration.password.stepTitle',
        defaultMessage: 'Create password',
        description: 'Registration password step title',
    },
    title: {
        id: 'registration.password.title',
        defaultMessage: 'Choose a password',
        description: 'Registration password title',
    },
    description: {
        id: 'registration.password.description',
        defaultMessage: 'Email address verified you can now proceed to create your password.',
        description: 'Registration password description',
    },
    doNotMatch: {
        id: 'registration.password.validations.noNotMatch',
        defaultMessage: 'The password entry fields do not match. Please enter the same password in both fields and try again.',
        description: 'Registration password do not match validation',
    },
});
exports.default = messages;
